import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
import { BrowserRouter } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "slick-carousel/slick/slick.css";
import "./sass/index.scss";
import { ToastContainer } from "react-toastify";
import { LocationProvider } from "./context/LocationContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
    <React.StrictMode>
        <LocationProvider>
            <BrowserRouter>
                <ToastContainer />
                <App />
            </BrowserRouter>
        </LocationProvider>
    </React.StrictMode>,
);
